import {
  DeckAssetPackSchema,
  type AssetPackLicense,
  type DeckAssetPack,
} from '../internal/types';

export type { AssetPackLicense, DeckAssetPack };

export const DECK_ASSET_PACKS: DeckAssetPack[] = [
  DeckAssetPackSchema.parse({
    id: 'symbolic-placeholders',
    label: 'Symbolic Placeholders',
    description:
      'Pack interno con placeholder simbolici, gradient e sigilli testuali. Garantisce funzionamento completo senza asset illustrati esterni.',
    enabled_by_default: true,
    bundled: true,
    license: 'placeholder-only' satisfies AssetPackLicense,
    provenance_note:
      'Asset grafici interni a Lilith Arcana OS, creati come segnaposto simbolici senza dipendenze di licensing esterno.',
    card_count: 78,
    has_thumbnails: true,
    has_full_images: false,
  }),
  DeckAssetPackSchema.parse({
    id: 'rws-original-reference',
    label: 'RWS Original Reference',
    description:
      'Pack di riferimento per futuri asset verificati di pubblico dominio. Non viene attivato in automatico finché la provenance del singolo file non è confermata.',
    enabled_by_default: false,
    bundled: false,
    license: 'public-domain' satisfies AssetPackLicense,
    provenance_note:
      'Pack disattivato per default. Usabile solo con asset verificati singolarmente e separati dal corpus testuale originale.',
    card_count: 78,
    has_thumbnails: false,
    has_full_images: false,
  }),
];
